var exports = {
  "l": "Hero__ZQ19CN",
};

module.exports = exports;
